import React from "react";
import "./ExplanationArea.css";

const ExplanationArea = ({ prompt, value, onChange, language }) => {
  const handleTextChange = (e) => {
    onChange(e.target.value);
  };

  const getPlaceholder = () => {
    if (language === "zh") {
      return "请简要说明您的核心考量...";
    }
    return "Briefly state your core consideration...";
  };

  const getCharacterCount = () => {
    return value ? value.length : 0;
  };

  const getMaxLength = () => {
    return 500; // Reasonable limit for explanations
  };

  return (
    <div className="explanation-area">
      <label htmlFor="explanation-textarea" className="explanation-label">
        {prompt}
      </label>
      <div className="textarea-container">
        <textarea
          id="explanation-textarea"
          className="explanation-textarea"
          value={value || ""}
          onChange={handleTextChange}
          placeholder={getPlaceholder()}
          maxLength={getMaxLength()}
          rows={4}
        />
        <div className="character-count">
          <span
            className={
              getCharacterCount() > getMaxLength() * 0.8 ? "warning" : ""
            }
          >
            {getCharacterCount()}/{getMaxLength()}
          </span>
        </div>
      </div>

      {value && value.length > 0 && (
        <div className="explanation-preview">
          <h5>{language === "zh" ? "您的解释：" : "Your explanation:"}</h5>
          <p className="preview-text">{value}</p>
        </div>
      )}
    </div>
  );
};

export default ExplanationArea;
